/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect } from "react";
import styles from "./Category.module.scss";
import { Button, Flex, Layout, Table, Typography, message, Rate, Popconfirm, Avatar, Image, Tag } from "antd";
import type { TableProps, GetProp } from "antd";

import type { SorterResult } from "antd/es/table/interface";
import { ApiService } from "api/api.service";
import { useNavigate, useSearchParams } from "react-router-dom";
import type { PopconfirmProps } from "antd";
import { TbTrash, TbEdit, TbPlus } from "react-icons/tb";
import DashboardLayout from "layout/DashboardLayout";
import { T_Testimonials } from "dtos/testimonial.dto";
import axios from "axios";
import PageTitle from "components/PageTitle";
interface DataType extends T_Testimonials {}

type TablePaginationConfig = Exclude<GetProp<TableProps, "pagination">, boolean>;
interface TableParams {
  pagination?: TablePaginationConfig;
  sortField?: SorterResult<any>["field"];
  sortOrder?: SorterResult<any>["order"];
  filters?: Parameters<GetProp<TableProps, "onChange">>[1];
}
const Testimonial = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [filters, setFilters] = useState<{
    page: number;
    limit: number;
    rating: number | undefined;
  }>({
    page: Number(searchParams.get("page")) === 0 ? 1 : (Number(searchParams.get("page")) ?? 1),
    limit: Number(searchParams.get("limit")) === 0 ? 10 : (Number(searchParams.get("limit")) ?? 10),
    rating: 0,
  });

  const deleteTestimonial = async (reviewId: string) => {
    try {
      const token = localStorage.getItem("accessToken");
      await axios.delete(`${import.meta.env.VITE_APP_API_URL}/testimonial/`, {
        data: { reviewId },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      message.success("Testimonial deleted successfully");
      testimonialList.refetch(); // Refresh data after deletion
    } catch (error) {
      console.error("Error deleting testimonial:", error);
      message.error("Failed to delete testimonial");
    }
  };
  const deleteCategory = ApiService.category.useDeleteByIdOrSlug();
  const [searchTerm, setSearchTerm] = useState("");

  const navigate = useNavigate();
  const [selectedCategory, setSelectedcategory] = useState("");
  const testimonialList = ApiService.testimonial.useGetAllPaginated({
    page: filters.page,
    limit: filters.limit,
    rating: filters.rating,
    term: searchTerm,
  });

  const columns: TableProps<DataType>["columns"] = [
    {
      title: "Customer Name",
      dataIndex: "customer_name",
      key: "customer_name",
      width: 180,
      ellipsis: true,
      render: (name: string, record: DataType, index: number) => {
        return (
          <Flex align="center" gap={8}>
            {record.image ? (
              <Image
                src={record.image}
                width={40}
                height={40}
                style={{ borderRadius: "50%", minWidth: 40, minHeight: 40 }}
              />
            ) : (
              <Avatar
                size={"large"}
                style={{ backgroundColor: "#2c362f", fontSize: "20px", minWidth: 40, minHeight: 40 }}
              >
                {record.customer_name.charAt(0).toUpperCase()}
              </Avatar>
            )}
            {/* <Link to={`/dashboard/category/${record.slug}`}> */}
            <Typography.Title level={5} className="w-[180px]">
              {record.customer_name}
            </Typography.Title>
            {/* </Link> */}
          </Flex>
        );
      },
    },
    {
      title: "Company Name",
      dataIndex: "company_name",
      key: "company_name",
      width: 200,

      render: (name: string, record: DataType, index: number) => {
        return (
          <Typography.Paragraph type="secondary" className="w-[200px]">
            {record.company_name?.substring(0, 50)}
            {record.company_name?.length > 50 ? "..." : ""}
          </Typography.Paragraph>
        );
      },
    },
    {
      title: "Company Position",
      dataIndex: "company_position",
      key: "company_position",
      width: 150,

      render: (name: string, record: DataType, index: number) => {
        return <Typography.Paragraph>{record.company_position}</Typography.Paragraph>;
      },
    },
    {
      title: "Rating",
      dataIndex: "rating",
      key: "rating",
      width: 150,
      align: "center",
      render: (rating: number) => {
        return <Rate disabled value={rating} count={5} />;
      },
      filters: Array(5)
        .fill(" ")
        .map((_, i) => ({
          text: <Tag>{`${i + 1}/5`}</Tag>,
          value: i + 1,
        })),
      onFilter: (value, record) => {
        return record.rating === value;
      },
    },
    {
      title: "Actions",
      key: "actions",
      width: 120,
      align: "center",
      render: (_: any, record: DataType) => (
        <Flex align="center" justify="center" gap={4}>
          <Button
            icon={<TbEdit style={{ fontSize: "20px" }} />}
            onClick={() => navigate(`/dashboard/testimonial/${record._id}?page=${filters.page}&limit=${filters.limit}`)}
            type="text"
          ></Button>
          <Popconfirm
            title="Are you sure to delete this testimonial?"
            onConfirm={() => deleteTestimonial(record._id)}
            okText="Yes"
            cancelText="No"
          >
            <Button icon={<TbTrash style={{ color: "red", fontSize: "20px" }} />} type="text"></Button>
          </Popconfirm>
        </Flex>
      ),
    },
  ];

  const handleTableChange = (pagination: TablePaginationConfig, keyFilters: Record<string, any | null>) => {
    console.log(keyFilters.rating);
    setFilters({
      page: pagination.current ?? 1,
      limit: pagination.pageSize ?? 10,
      rating: keyFilters.rating[0] ?? 0,
    });
  };

  const cancel: PopconfirmProps["onCancel"] = (e) => {};

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };

  const confirm = (e: any) => {
    try {
      deleteCategory.mutate(selectedCategory, {
        onSuccess: () => {
          message.success("Category deleted successfully");
          if (searchTerm) {
            testimonialList.refetch();
          } else {
            testimonialList.refetch();
          }
        },
        onError: () => {},
      });
    } catch (error: any) {
      console.log(error);
      message.error(`category can't be deleted ${error.errorFields[0].errors[0]}`);
    }
  };

  useEffect(() => {
    let getSearchData: NodeJS.Timeout | undefined;

    if (searchTerm) {
      getSearchData = setTimeout(() => {
        testimonialList.refetch();
      }, 2000);
    }

    return () => {
      if (getSearchData) clearTimeout(getSearchData);
    };
  }, [searchTerm]);

  return (
    <DashboardLayout
      headerRight={
        <Button
          type="primary"
          onClick={() => {
            navigate(`/dashboard/create-testimonial`);
          }}
          icon={<TbPlus />}
        >
          Add Testimonial
        </Button>
      }
    >
      <PageTitle title="Testimonals" pageTitle={[{ title: "Testimonals" }]} />
      <Table
        virtual
        loading={searchTerm ? testimonialList.isLoading : testimonialList.isLoading}
        columns={columns}
        onChange={handleTableChange}
        rowKey={(record) => record._id}
        dataSource={searchTerm ? testimonialList.data?.data : testimonialList.data?.data}
        pagination={{
          showSizeChanger: true,
          total: searchTerm ? testimonialList.data?.totalObjects : testimonialList.data?.totalObjects,
          pageSize: filters.limit,
          current: filters.page,
          onChange: (page, pageSize) => {
            setFilters((prev) => ({ ...prev, page, limit: pageSize }));
          },
        }}
      />
    </DashboardLayout>
  );
};

export default Testimonial;
